import { Box, HStack, Stack } from '@chakra-ui/core';
import React, { useLayoutEffect, useRef, useState } from 'react';
import { DeleteQuestion } from './DeleteQuestion';
import { QuestionDraggableButton } from './QuestionDraggableButton';
import { QuestionExpandleButton } from './QuestionExpandleButton';
import { QuestionImageInput } from './QuestionImageInput';
import { QuestionInput } from './QuestionInput';
import { QuestionNumber } from './QuestionNumber';
import { QuestionTypeChip } from './QuestionTypeChip';

const WRAPPER_STYLES = {
  px: 4,
  align: 'center',
  borderBottom: '1px solid',
  borderColor: 'rgba(174, 208, 255, 1)',
  spacing: 2,

  position: 'relative',
  minH: '62px',
} as const;

export const QuestionElementHeader = React.memo(function QuestionElementHeader({ id }: { id: string }) {
  const sourceRef = useRef<HTMLDivElement>(null);

  const [paddingRight, setPaddingRight] = useState(0);

  useLayoutEffect(() => {
    /* istanbul ignore else */
    if (sourceRef.current) {
      setPaddingRight(sourceRef.current.offsetWidth);
    }
  }, []);

  return (
    <Stack sx={{ borderBottom: '1px solid', borderColor: '#E5E7EB' }} spacing={0}>
      <HStack
        {...WRAPPER_STYLES}
        sx={{
          justifyContent: 'space-between',
          '&:has([aria-invalid="true"])': {
            bg: 'rgba(255, 0, 0, 0.05)',
            borderRadius: 'md',
            boxShadow: 'inset 0 0 4px rgba(255, 0, 0, 0.6)',
          },
        }}
      >
        <HStack>
          <QuestionDraggableButton id={id} />

          <QuestionNumber id={id} />

          <QuestionExpandleButton id={id} />
        </HStack>

        <HStack ref={sourceRef} spacing={2}>
          <QuestionImageInput id={id} />
          <QuestionTypeChip elementId={id} />
          <DeleteQuestion id={id} />
        </HStack>
      </HStack>
      <Box px={4} py={2}>
        <QuestionInput id={id} paddingRight={paddingRight} />
      </Box>
    </Stack>
  );
});
